var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outline-div-container",attrs:{"contenteditable":_vm.editable,"id":_vm.id},on:{"keydown":_vm.keyDownhandler,"paste":_vm.handlePaste,"blur":_vm.blurHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }